import { ICurrentRegion } from '../../types/geoLocation/currentRegion';
import { IApplicationState } from '../../types/redux';

export function selectCurrentRegion(state: IApplicationState): ICurrentRegion {
  return state.geoLocation.currentRegion;
}
